import {Injectable} from '@angular/core';
import {HttpClient} from '@angular/common/http';
import {BaseApiTemplateService} from '../shared/base-api-template-service.model';
import {Core2Config} from '../shared/core2Config';
import {SellerPanelContainerModel} from '../../../../../models/aggregates/seller-panel/seller-panel-container.model';


@Injectable({
  providedIn: 'root'
})
export class SellerProductTempService extends BaseApiTemplateService<SellerPanelContainerModel> {
  constructor(http: HttpClient) {
    super();
    this.apiUrl = Core2Config.DOMAIN_URL + Core2Config.TENANT_DOMAIN_URL_PREFIX + 'mkp/items/new-login-entity-ep';
    this.endpoint_path = Core2Config.TENANT_DOMAIN_URL_PREFIX + 'mkp/items/new-login-entity-ep';
    this.httpClient = http;
  }
}